// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
// import FastClick from 'fastclick'
import '@/api/routerChange'
import 'mint-ui/lib/style.css'
import Icon from 'vue2-svg-icon/Icon.vue'
import store from './store'
import * as filters from './filter'
import vueCookie from 'vue-cookies'
// import VueAMap from 'vue-amap'
// import { lazyAMapApiLoaderInstance } from 'vue-amap'
import '@/common/font/font.css'
import Bridge from './api/bridge.js'
import { InfiniteScroll, Indicator, Loadmore, Spinner, Cell, MessageBox, Toast, Picker } from 'mint-ui'
import 'animate.css'
import 'vue-fullpage/vue-fullpage.css'
import VueFullpage from 'vue-fullpage'
Vue.use(VueFullpage)

Vue.component('icon', Icon)

// Vue.use(VueAMap)
Vue.use(vueCookie)
Vue.use(InfiniteScroll)
Vue.component(Loadmore.name, Loadmore)
Vue.component(Picker.name, Picker)
Vue.component(Spinner.name, Spinner)
Vue.component(Cell.name, Cell)
Vue.prototype.$loading = Indicator
Vue.prototype.$message = MessageBox
Vue.prototype.$toast = Toast
Vue.prototype.$bridge = Bridge

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// FastClick.attach(document.body)
// FastClick.prototype.onTouchEnd = function (event) {
//   if (event.target.hasAttribute('type') && event.target.getAttribute('type') === 'text') {
//     event.preventDefault()
//     return false
//   }
// }
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js